// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toolbar {\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n}\n\n.resend {\n  padding-left: 3rem;\n  padding-bottom: 1rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
